import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@barthauer/basys/core/authentication';
import { WorkmodeSelectionComponent } from './workmode/workmode-selection/workmode-selection.component';
import { OrderSelectionComponent } from './order-selection/order-selection.component';
import { AppService } from './services/app.service';

export const rootRoutes: Routes = [
  {
    path: AppService.Route_WorkModeSelection,
    outlet: 'mainOutlet',
    canActivate: [AuthenticationGuard],
    component: WorkmodeSelectionComponent,
  },
  {
    path: AppService.Route_OrderSelection,
    outlet: 'mainOutlet',
    canActivate: [AuthenticationGuard],
    component: OrderSelectionComponent,
  },
];

export const operaWorkModeRootRoute = [
  {
    path: AppService.Route_WorkModeSelection,
    outlet: 'mainOutlet',
    canActivate: [AuthenticationGuard],
    component: WorkmodeSelectionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild([])],
  exports: [RouterModule],
  providers: [
    provideAppInitializer(() => {
      const router = inject(Router);
      return appInitFactory(router)();
    }),
  ],
})
export class RoutingModule {
  constructor() {}
}

export function appInitFactory(router: Router) {
  return (): void => {
    router.resetConfig([...router.config, ...rootRoutes]);
  };
}
